import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-371ed344"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "etf-container" }

import { onMounted, ref, watch } from "vue";
import { etfExport } from '@/service/etf/etf'
import {  ElMessage } from 'element-plus'



export default /*#__PURE__*/_defineComponent({
  __name: 'etfExport',
  setup(__props) {

onMounted(() => {
 
})

const isLoading=ref(false);

const handleImportError = (res: any) => {
  console.log(res)
}
function uploadFile(file : any) {
    isLoading.value=true;
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('file', file.file);

        etfExport(formData, 'blob' ).then((res) => {
            const blob = new Blob([res], {
            type: 'application/octet-stream'
            })
            const down = document.createElement('a')
            down.download = 'ETF数据导出.zip'
            down.style.display = 'none'
            down.href = URL.createObjectURL(blob)
            document.body.appendChild(down)
            down.click()
            URL.revokeObjectURL(down.href)
            document.body.removeChild(down)
            ElMessage.success('导出成功')
            isLoading.value=false;
            resolve()
        })
        .catch(error => {
          isLoading.value=false;
          reject(error)
           
        })
    })
  }



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_upload, {
      style: {"display":"inline-block","margin-left":"10px","margin-right":"10px"},
      accept: ".xls,.xlsx",
      "on-error": handleImportError,
      "http-request": uploadFile,
      "show-file-list": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("导入")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    })
  ]))
}
}

})